//Imports node_modules
import React, { useContext, useEffect, useState } from 'react'
import { CSSTransition } from 'react-transition-group';
import Modal from 'react-modal';

//Imports Css
import './FormModal.css'

//Imports Components

//Import Data
import { globalModals } from '../../../../data/GlobalModals'
import { globalForms } from '../../../../data/GlobalForms';
import { globalFunctions } from '../../../../data/GlobalFunctions';
import ButtonAdvanced from '../../buttonAdvanced/ButtonAdvanced';

//Layout de navegação na parte inferior da aplicação
const FormModal = (params) => {

    Modal.setAppElement('body');

    const [currentIndex, setCurrentIndex] = useState(0);

    const {
        advancedClick
    } = useContext(globalFunctions);

    const {
        formModalStatus,
        DismisFormModal,
        modalInfo,
    } = useContext(globalModals)

    const {
        formFildsByType,
        OnChangeField,
        ResetStateForms,
        OnNextClicked,
    } = useContext(globalForms)

    const [showInvalidAlert, setShowInvalidAlert] = useState(false);

    function toggleModal() {
        ResetStateForms();
        DismisFormModal();
    };


    //Estilos para o header
    let classesHeader = 'modal-header '
    switch (formFildsByType[currentIndex].formStyle) {
        case 'info': classesHeader += 'info';
            break;
        case 'success': classesHeader += 'success';
            break;
        case 'caution': classesHeader += 'caution';
            break;
        case 'warning': classesHeader += 'warning';
            break;
        case 'error': classesHeader += 'error';
            break;
        case 'message':
            break;
        default:
            break;
    }

    let classesButtonNext = 'modalBtn '
    switch (formFildsByType[currentIndex].formStyle) {
        case 'info': classesButtonNext += 'info';
            break;
        case 'success': classesButtonNext += 'success';
            break;
        case 'caution': classesButtonNext += 'caution';
            break;
        case 'warning': classesButtonNext += 'warning';
            break;
        case 'error': classesButtonNext += 'error';
            break;
        case 'message': classesButtonNext += 'message';
            break;
        default: classesButtonNext += 'message';
            break;
    }

    function handleKeyDown(e) {
        if (e.key === 'Enter') {
            nextButton(formFildsByType[currentIndex].nameForm, formFildsByType[currentIndex].fields)
        }
    }

    //Provavelment remover isto no futuro
    let iconClasse = 'fa fa-pencil';

    useEffect(() => {
        Object.keys(formFildsByType).forEach(function (formInfo, index) {
            if (formFildsByType[index].nameForm === modalInfo.modaltype) {
                setCurrentIndex(index)
            }
        });
        // eslint-disable-next-line
    }, [formFildsByType, modalInfo.modaltype]);

    function generateModalFormBody() {
        return Object.values(formFildsByType[currentIndex].fields).map((formfields, index) =>
            <div key={index} className="col-md-12 col-sm-12" style={{ marginBottom: '10px' }} >
                <label className="form-label">{formfields.name}</label>
                <input placeholder={formfields.placeholder} type={formfields.type} className="form-control form-control" value={formfields.value} onKeyDown={handleKeyDown} onChange={e => OnChangeField(modalInfo.modaltype, formfields.name, e.target.value)}>
                </input>
            </div>
        )
    }

    function generateModalButtons() {
        return (
            <div className="modal-footer">

                {formFildsByType[currentIndex].noback ?
                    <div></div>
                    :
                    <ButtonAdvanced
                        type="button"
                        className='modalBtn modalBtn-light'
                        onClick={e => toggleModal()}
                        text='Cancelar'></ButtonAdvanced>
                }

                <ButtonAdvanced
                    type="button"
                    className={classesButtonNext}
                    onClick={e => nextButton(formFildsByType[currentIndex].nameForm, formFildsByType[currentIndex].fields)}
                    text='Concluir'></ButtonAdvanced>
            </div>
        )
    }

    function nextButton(nameForm, fields) {

        var invalidCounter = 0;

        Object.keys(fields).forEach(function (field, index) {
            if (fields[index].value === "") {
                invalidCounter = invalidCounter + 1;
                setShowInvalidAlert(true);
            }
        });

        if (invalidCounter === 0) {
            OnNextClicked(nameForm, fields)
        }
    }

    function generateInvalidAlert() {
        if (showInvalidAlert) {
            return (
                <div className="alert alert-danger" role="alert">
                    <button type="button" className="close-alert" onClick={e => advancedClick(e, (e => setShowInvalidAlert(false)))}>×</button>
                    <i className={iconClasse} aria-hidden="true" style={{ marginRight: '10px', fontSize: '17px', padding: '0px' }}></i>
                    Por favor preencha todos os campos!
                </div>
            )
        }
    }

    return (
        <div>
            <CSSTransition
                in={formModalStatus}
                timeout={300}
                classNames="dialog">
                <Modal
                    closeTimeoutMS={100}
                    isOpen={formModalStatus}
                    className="Modal"
                    overlayClassName="Overlay"
                    disableAutoFocus={true}>
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className={classesHeader} style={{ fontSize: '1.2rem' }}>
                                <h4 className="modal-title" id="staticBackdropLabel">
                                    <i className={iconClasse} aria-hidden="true" style={{ marginRight: '10px', fontSize: '20px', padding: '0px' }}></i>{formFildsByType[currentIndex].titleForm}
                                </h4>
                            </div>
                            <div className="modal-body">
                                {formFildsByType[currentIndex].description === '' ? false :
                                    <div className="col-md-12 col-sm-12">
                                        <div className="h5 card-title">Descrição:</div>
                                        <p className="card-title-desc">{formFildsByType[currentIndex].description}</p>
                                    </div>}
                                <div className="col-md-12 col-sm-12">
                                    {generateInvalidAlert()}
                                </div>
                                <div className="col-md-12 col-sm-12">
                                    {generateModalFormBody()}
                                </div>
                            </div>
                            {generateModalButtons()}
                        </div>
                    </div>
                </Modal>
            </CSSTransition>
        </div>
    )
}

export default FormModal